module.exports = __webpack_public_path__ + "img/user-head.cba5523b.jpg";